import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import * as handler from "../Actions/main";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const IOSSwitch = withStyles(theme => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none"
      }
    },
    "&$focusVisible $thumb": {
      color: "#CECECE",
      border: "6px solid #fff" //52d869
    }
  },
  thumb: {
    width: 24,
    height: 24 // theme.palette.grey[50]
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: "#CECECE",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"])
  },
  checked: {},
  focusVisible: {}
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  );
});

function CustomizedSwitches(props) {
  const [state, setState] = React.useState({
    checkedB: false
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
    props.change();
  };

  return (
    <FormControlLabel
      labelPlacement="start"
      style={{ margin: "0px" }}
      control={
        <IOSSwitch
          checked={state.checkedB}
          onChange={handleChange("checkedB")}
          value="checkedB"
        />
      }
    />
  );
}

const mapDispatchToProps = dispatch => {
  return {
    change: () => dispatch(handler.toggel())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(CustomizedSwitches);
